import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatPublicWorkHistoryLayerList } from './public-work-history-layer.helper';
import { PublicWorkHistoryLayerActions } from './public-work-history-layer.redux';
import { IPayloadGetPublicWorkHistoryLayerListRequest } from './public-work-history-layer.type';

export function* getPublicWorkHistoryLayerList(
	action: PayloadAction<IPayloadGetPublicWorkHistoryLayerListRequest>
) {
	const { franchiseId, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetPublicWorkHistoryLayerListResponse> =
			yield API.getPublicWorkHistoryLayerList(franchiseId);
		const content = formatPublicWorkHistoryLayerList(res?.data);

		yield put(
			PublicWorkHistoryLayerActions.getPublicWorkHistoryLayerListSuccess({
				content,
			})
		);

		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			PublicWorkHistoryLayerActions.getPublicWorkHistoryLayerListFailure()
		);
	}
}
